import { render, staticRenderFns } from "./FaqDisplay.vue?vue&type=template&id=0bf779b5"
import script from "./FaqDisplay.vue?vue&type=script&lang=ts"
export * from "./FaqDisplay.vue?vue&type=script&lang=ts"
import style0 from "./FaqDisplay.vue?vue&type=style&index=0&id=0bf779b5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports